export default __webpack_public_path__ + "static/media/11-interview-principles.ae3e6357.png";